import type { RouteObject } from "react-router-dom";
import PatientsSearch from "./patients-search";
import ReportActivity from "./report-activity";
import ReportCashRegister from "./report-cash-register";
import ReportConsultationsPlanned from "./report-consultations-planned";
import ReportFinancial from "./report-financial";
import ReportStatistical from "./report-statistical";
import ReportSurgical from "./report-surgical";
import ReportSurgicalSuggestion from "./report-surgical-suggestion";

export function RouterReports(): RouteObject[] {
  return [
    { path: "/search", element: <PatientsSearch /> },
    { path: "/report/activity", element: <ReportActivity /> },
    {
      path: "/report/consultations-planned",
      element: <ReportConsultationsPlanned />
    },
    { path: "/report/cash-register", element: <ReportCashRegister /> },
    { path: "/report/financial", element: <ReportFinancial /> },
    { path: "/report/statistical", element: <ReportStatistical /> },
    { path: "/report/surgical", element: <ReportSurgical /> },
    {
      path: "/report/surgical-suggestion",
      element: <ReportSurgicalSuggestion />
    }
  ];
}
